import { InjectionToken, Provider } from '@angular/core';
import { FirebaseApp, FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Firestore, getFirestore } from 'firebase/firestore';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('FIREBASE_APP');
export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');
export const FIRESTORE = new InjectionToken<Firestore>('FIRESTORE');

/**
 * Providers for the Firebase JS SDK instances used across the app.
 * The app is initialized lazily so unit tests that never inject these tokens
 * do not create a Firebase app.
 */
export function provideFirebase(config: FirebaseOptions): Provider[] {
  return [
    {
      provide: FIREBASE_APP,
      useFactory: () => (getApps().length ? getApp() : initializeApp(config)),
    },
    {
      provide: FIREBASE_AUTH,
      useFactory: (app: FirebaseApp) => getAuth(app),
      deps: [FIREBASE_APP],
    },
    {
      provide: FIRESTORE,
      useFactory: (app: FirebaseApp) => getFirestore(app),
      deps: [FIREBASE_APP],
    },
  ];
}
